import React from "react";
import img from "../../assets/whatsapp.png";
import { maskNumberInt } from "../../utils/regex";
import { texts } from "../../utils/texts";
import { ReturnName, ReturnNamePage } from "../../utils/coins";

export default function WhatsappIcon() {
  return (
    <div className="position-relative">
      <div className="position-fixed bottom-0 end-0 p-4 d-flex justify-content-end">
        <a
          className=""
          href={`https://web.whatsapp.com/send?phone=${texts.phone}`}
          rel="noopene noreferrer"
          target="_blank"
        >
          <img src={img} width="50px" alt="ícone do Whatsapp"></img>
        </a>
      </div>
    </div>
  );
}
export function RedirectWhatsapp({ number }) {
  return (
    <>
      {number ? (
        <a
          className=""
          href={`https://api.whatsapp.com/send?phone=${maskNumberInt(
            number
          )}&type=phone_number&app_absent=0`}
          rel="noopene noreferrer"
          target="_blank"
        >
          {number}
        </a>
      ) : null}
    </>
  );
}

export function RedirectWhatsappMain(message) {
    const encodedMessage = encodeURIComponent(message);
    const url = `https://api.whatsapp.com/send?phone=${texts.phone}&text=${encodedMessage}`;
    window.open(url, '_blank');
}
export function RedirectTel({ number }) {
  return (
    <>
      {number ? (
        <a
          className=""
          href={`tel:+55${maskNumberInt(number)}`}
          rel="noopene noreferrer"
          target="_blank"
        >
          {number}
        </a>
      ) : null}
    </>
  );
}

export function RedirectMail({ mail }) {
  return (
    <>
      {mail ? (
        <a
          className=""
          href={`mailto:${mail}`}
          rel="noopene noreferrer"
          target="_blank"
        >
          {mail}
        </a>
      ) : null}
    </>
  );
}


export function formatTextProducts(products) {
    let texto = "Solicito atendimento humanizado:";
    let total = 0;
    let moeda = "";
    products.forEach((item) => {
      moeda +=
        "%0A%0AProduto: " +
        (ReturnName(item.codIso) || item.nome) +
        "%0ACotação: " +
         (ReturnNamePage(item.tipo) || item.tipo) +
        "%0AQuantidade: " +
        item.quantidade
        moeda += item.modelo? "%0ACartão OuroFácil: " + item.modelo : ""
      moeda +=
        "              Valor: " +
        (item.quantidade * item.valor).toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL",
        });
      total += item.quantidade * item.valor;
    });
    texto +=
      moeda +
      "%0A%0ATotal: " +
      total.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    return texto;
  }